import React from "react";
import classNames from "classnames";
import NoColorImg from "icons/no_color.svg";
import * as styles from "./styles.module.scss";
const DefaultColorSelectButton = ({ value, className, onClick, disabled }) => (React.createElement("button", { disabled: disabled, className: classNames(styles.root, className), onClick: onClick }, value ? (React.createElement("div", { className: styles.selectedColor, style: { backgroundColor: value } })) : (React.createElement(NoColorImg, { className: classNames(styles.selectedColor, styles.noColor) }))));
export default DefaultColorSelectButton;
